<template>
    <div class="manage">
        <Header @cart-ref="setCartRef" />
        <div id="loading-overlay" v-if="loading">
            <img src="../assets/gifs/loading.gif" alt="Carregando" class="loading-gif">
        </div>
        <div class="main-content" v-show="!loading">
            <!-- Visão Admin Sistema -->
            <div class="manage-container" v-if="!isInstitutionalAdmin">
                <div class="manage-tabs">
                    <button :class="['tab-btn', { active: activeTab === 'analytics' }]"
                        @click="activeTab = 'analytics'">
                        <i class="fas fa-chart-line"></i> Analytics e Vendas
                    </button>
                    <button :class="['tab-btn', { active: activeTab === 'catalog' }]" @click="activeTab = 'catalog'">
                        <i class="fas fa-book"></i> Catálogo de Materiais
                    </button>
                </div>

                <!-- ABA: ANALYTICS -->
                <div v-if="activeTab === 'analytics'" class="tab-content">
                    <h2 class="title-manage section-title" style="text-align: left; margin-bottom: 30px;">Dashboard de
                        Vendas</h2>

                    <!-- KPIs -->
                    <div class="kpi-grid">
                        <div class="kpi-card">
                            <div class="kpi-icon green"><i class="fas fa-dollar-sign"></i></div>
                            <div class="kpi-info">
                                <span>Receita Total Acumulada</span>
                                <h3>R$ {{ formatPrice(dashboardKpis.receitaTotal) }}</h3>
                            </div>
                        </div>
                        <div class="kpi-card">
                            <div class="kpi-icon blue"><i class="fas fa-users"></i></div>
                            <div class="kpi-info">
                                <span>Acessos Vendidos</span>
                                <h3>{{ dashboardKpis.acessosVendidos }}</h3>
                            </div>
                        </div>
                        <div class="kpi-card">
                            <div class="kpi-icon purple"><i class="fas fa-handshake"></i></div>
                            <div class="kpi-info">
                                <span>Parceiros Ativos</span>
                                <h3>{{ dashboardKpis.parceirosAtivos }}</h3>
                            </div>
                        </div>
                        <div class="kpi-card">
                            <div class="kpi-icon yellow"><i class="fas fa-book-open"></i></div>
                            <div class="kpi-info">
                                <span>Materiais no Catálogo</span>
                                <h3>{{ materiais.length }}</h3>
                            </div>
                        </div>
                    </div>

                    <div class="dashboard-tables">
                        <!-- Top 5 Mais Vendidos -->
                        <div class="dash-table-wrapper">
                            <h3 class="dash-title"><i class="fas fa-trophy" style="color: #f1c40f;"></i> Materiais Mais
                                Vendidos</h3>
                            <table class="dash-table">
                                <thead>
                                    <tr>
                                        <th>Material</th>
                                        <th>Vendas</th>
                                        <th>Receita Gerada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in topVendidos" :key="'vendido-' + index">
                                        <td><strong>{{ index + 1 }}º</strong> {{ item.nome }}</td>
                                        <td>{{ item.vendas }}</td>
                                        <td class="text-success"><strong>R$ {{ formatPrice(item.receita) }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Top Parceiros Acessos -->
                        <div class="dash-table-wrapper">
                            <h3 class="dash-title"><i class="fas fa-chart-pie" style="color: #3498db;"></i> Maiores
                                Volumes de Acessos</h3>
                            <table class="dash-table">
                                <thead>
                                    <tr>
                                        <th>Material</th>
                                        <th>Parceiro Comprador</th>
                                        <th>Acessos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in topAcessos" :key="'acesso-' + index">
                                        <td>{{ item.nome }}</td>
                                        <td>{{ item.parceiro }}</td>
                                        <td><span class="badge-acessos">{{ item.acessos }} licenças</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- ABA: CATÁLOGO DE MATERIAIS -->
                <div v-if="activeTab === 'catalog'" class="tab-content">
                    <div class="header-search">
                        <Search @filtro-atualizado="atualizarFiltro" />
                    </div>

                    <div class="manage-header">
                        <h2 class="title-manage">Gestão de Materiais</h2>
                        <!-- <button class="btn-add-material" @click="novoMaterial">
                            <i class="fas fa-plus"></i> Novo Material
                        </button> -->
                    </div>

                    <div class="table-responsive">
                        <table class="manage-table">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Nome</th>
                                    <th>Visibilidade</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in materiaisFiltrados"
                                    :key="item.codigo_disciplina + '-' + index">
                                    <td>{{ item.codigo_disciplina }}</td>
                                    <td>{{ item.nome_disciplina }}</td>
                                    <td>
                                        <span :class="['status-badge', item.visivel === false ? 'cancelado' : 'ativo']">
                                            {{ item.visivel === false ? 'Oculto' : 'Visível' }}
                                        </span>
                                    </td>
                                    <td class="actions-cell">
                                        <button
                                            :class="['btn-toggle-visibility', item.visivel === false ? 'show' : 'hide']"
                                            @click="toggleVisibilidade(item)"
                                            :title="item.visivel === false ? 'Tornar Visível' : 'Ocultar'">
                                            <i :class="item.visivel === false ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                                            {{ item.visivel === false ? 'Exibir' : 'Ocultar' }}
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="materiaisFiltrados.length === 0">
                                    <td colspan="4" class="empty-state">Nenhum material encontrado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Visão Admin Institucional (Parceiro) -->
            <div class="manage-container partner-view" v-if="isInstitutionalAdmin">
                <div class="manage-tabs">
                    <button :class="['tab-btn', { active: activePartnerTab === 'subscriptions' }]"
                        @click="activePartnerTab = 'subscriptions'">
                        <i class="fas fa-box-open"></i> Minhas Assinaturas
                    </button>
                    <button :class="['tab-btn', { active: activePartnerTab === 'iframes' }]"
                        @click="activePartnerTab = 'iframes'">
                        <i class="fas fa-code"></i> Meus Cursos (iFrames)
                    </button>
                </div>

                <!-- Aba: Minhas Assinaturas -->
                <div v-if="activePartnerTab === 'subscriptions'" class="tab-content">
                    <div class="header-search">
                        <Search @filtro-atualizado="atualizarFiltro" />
                    </div>

                    <div class="manage-header">
                        <h2 class="title-manage">Materiais Contratados</h2>
                    </div>

                    <div class="table-responsive">
                        <table class="manage-table">
                            <thead>
                                <tr>
                                    <th>Material / Pacote</th>
                                    <th>Acessos Comprados</th>
                                    <th>Próximo Pagamento</th>
                                    <th>Valor Mensal (R$)</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="assinatura in assinaturasFiltradas" :key="assinatura.id">
                                    <td><strong>{{ assinatura.nome }}</strong></td>
                                    <td>{{ assinatura.acessos }}</td>
                                    <td>
                                        {{ formatarData(assinatura.proximoPagamento) }}
                                        <span class="days-left" v-if="assinatura.status !== 'Cancelado'">({{
                                            calcularDias(assinatura.proximoPagamento) }})</span>
                                    </td>
                                    <td>{{ formatPrice(assinatura.valor) }}</td>
                                    <td>
                                        <span :class="['status-badge', assinatura.status.toLowerCase()]">
                                            {{ assinatura.status }}
                                        </span>
                                    </td>
                                    <td class="actions-cell">
                                        <button v-if="assinatura.status === 'Ativo'" class="btn-action cancel"
                                            @click="cancelarAssinatura(assinatura)" title="Cancelar p/ Próximo Mês">
                                            Cancelar
                                        </button>
                                        <button v-if="assinatura.status === 'Cancelado'" class="btn-action reactivate"
                                            @click="reativarAssinatura(assinatura)" title="Reativar e Pagar">
                                            Reativar / Pagar
                                        </button>
                                        <button v-if="assinatura.status === 'Pendente'" class="btn-action pay"
                                            @click="pagarAssinatura(assinatura)" title="Fazer Pagamento">
                                            Pagar Agora
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="assinaturasFiltradas.length === 0">
                                    <td colspan="6" class="empty-state">Nenhuma assinatura encontrada.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Aba: Meus Cursos (iFrames) -->
                <div v-if="activePartnerTab === 'iframes'" class="tab-content">
                    <div class="manage-header">
                        <h2 class="title-manage">Meus Cursos e iFrames</h2>
                        <button class="btn-add-material" @click="openIframeModal">
                            <i class="fas fa-plus"></i> Novo Curso
                        </button>
                    </div>

                    <div class="iframe-grid">
                        <div class="iframe-card" v-for="iframe in iframes" :key="iframe.id"
                            :class="{ 'inactive': !iframe.ativo }">
                            <div class="iframe-card-header">
                                <h3>
                                    {{ iframe.nome }}
                                    <span v-if="!iframe.ativo" class="status-badge cancelado"
                                        style="margin-left: 10px; font-size: 0.7rem;">Inativo</span>
                                </h3>
                                <span class="badge-acessos">{{ iframe.materiaisCount }} materiais</span>
                            </div>
                            <div class="iframe-card-body">
                                <p>Criado em: {{ formatarData(iframe.createdAt) }}</p>
                                <p v-if="iframe.allowed_domains && iframe.allowed_domains.length">
                                    <strong>Domínios:</strong> {{ iframe.allowed_domains.join(', ') }}
                                </p>
                                <p v-else>
                                    <strong>Domínios:</strong> Todos permitidos
                                </p>
                                <div class="iframe-actions">
                                    <button class="btn-action pay" @click="copyIframeCode(iframe)"
                                        title="Copiar código iFrame" :disabled="!iframe.ativo">
                                        <i class="fas fa-copy"></i> Copiar iFrame
                                    </button>
                                    <button class="btn-action reactivate" @click="openIframeModal(iframe)"
                                        title="Editar Materiais">
                                        <i class="fas fa-edit"></i> Editar
                                    </button>
                                    <button :class="['btn-action', iframe.ativo ? 'cancel' : 'reactivate']"
                                        @click="toggleIframe(iframe)"
                                        :title="iframe.ativo ? 'Desativar iFrame' : 'Ativar iFrame'">
                                        <i :class="iframe.ativo ? 'fas fa-power-off' : 'fas fa-play'"></i>
                                        {{ iframe.ativo ? 'Desativar' : 'Ativar' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="iframes.length === 0" class="empty-state" style="grid-column: 1 / -1;">
                            Nenhum curso montado ainda. Clique em "Novo Curso" para criar o seu primeiro iFrame!
                        </div>
                    </div>
                </div>

                <!-- Modal de Criação de iFrame -->
                <CourseModal :is-open="showIframeModal" :initial-data="selectedIframe" :assinaturas="assinaturas"
                    @close="closeIframeModal" @save="saveIframe" />
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import Search from '../components/Search.vue';
import CourseModal from '../components/CourseModal/CourseModal.vue';
import request from '../router/request';
import requestV2 from '@/router/requestV2.js';

export default {
    name: 'ManageView',
    components: {
        Header,
        Search,
        CourseModal
    },
    data() {
        return {
            loading: true,
            materiais: [],
            search: '',
            cartComponent: null,
            userProfile: null,
            activeTab: 'analytics',
            activePartnerTab: 'subscriptions',
            showIframeModal: false,
            selectedIframe: null,
            iframes: [],
            dashboardKpis: {
                receitaTotal: 0,
                acessosVendidos: 0,
                parceirosAtivos: 0,
                totalAccesses: 0,
                usedAccesses: 0,
                licensedMaterials: 0
            },
            topVendidos: [],
            topAcessos: [],
            assinaturas: []
        };
    },
    computed: {
        isSystemAdmin() {
            return this.userProfile && Number(this.userProfile.is_admin) === 1;
        },
        isInstitutionalAdmin() {
            return this.userProfile && Number(this.userProfile.codigo_perfil) === 1 && Number(this.userProfile.is_admin) === 0;
        },
        materiaisFiltrados() {
            if (!this.search) return this.materiais;
            const termo = this.search.toLowerCase();
            return this.materiais.filter(item =>
                (item.nome_disciplina && item.nome_disciplina.toLowerCase().includes(termo)) ||
                (item.codigo_disciplina && item.codigo_disciplina.toString().includes(termo))
            );
        },
        assinaturasFiltradas() {
            if (!this.search) return this.assinaturas;
            const termo = this.search.toLowerCase();
            return this.assinaturas.filter(item =>
                (item.nome && item.nome.toLowerCase().includes(termo)) ||
                (item.status && item.status.toLowerCase().includes(termo))
            );
        }
    },
    methods: {
        atualizarFiltro(filtro) {
            this.search = filtro.texto;
        },
        carregarMateriais() {
            this.loading = true;
            request.post('ava/listarBiblVirtual')
                .then(response => {
                    const resultado = response.data;
                    let lista = [];
                    if (Array.isArray(resultado)) {
                        lista = resultado;
                    } else if (Array.isArray(resultado.data)) {
                        lista = resultado.data;
                    }
                    this.materiais = lista;
                })
                .catch(err => {
                    console.error('Erro ao carregar materiais:', err);
                    alert('Erro ao carregar a lista de materiais.');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        novoMaterial() {
            alert('Funcionalidade de adicionar novo material em desenvolvimento.');
        },
        toggleVisibilidade(item) {
            // Como "visivel" é undefined por padrão (entendido como true), inicializamos se necessário
            if (item.visivel === undefined) {
                this.$set(item, 'visivel', true);
            }
            item.visivel = !item.visivel;
            // Aqui normalmente faríamos uma chamada à API para atualizar o status no banco de dados.
        },
        async cancelarAssinatura(assinatura) {
            if (confirm(`Deseja cancelar a assinatura de "${assinatura.nome}"? Essa ação será refletida no Pagar.me.`)) {
                try {
                    await requestV2.put(`/subscriptions/${assinatura.id}/cancel`);
                    alert('Assinatura cancelada com sucesso no Pagar.me!');
                    // Recarrega dados do backend para refletir status atualizado
                    await this.loadPartnerData();
                } catch (e) {
                    const msg = e.response?.data?.message || 'Erro ao cancelar assinatura.';
                    alert(msg);
                }
            }
        },
        async reativarAssinatura(assinatura) {
            if (confirm(`Deseja reativar a assinatura de "${assinatura.nome}" e prosseguir com o pagamento?`)) {
                try {
                    await requestV2.put(`/subscriptions/${assinatura.id}/reactivate`);
                    assinatura.status = 'Ativo';
                    alert('Assinatura reativada com sucesso. Redirecionando para pagamento...');
                } catch (e) {
                    alert('Erro ao reativar assinatura');
                }
            }
        },
        pagarAssinatura(assinatura) {
            alert(`Gerando link de pagamento para "${assinatura.nome}" no valor de R$ ${this.formatPrice(assinatura.valor)}...`);
            assinatura.status = 'Ativo'; // Simula pagamento
        },
        openIframeModal(iframe = null) {
            this.selectedIframe = iframe;
            this.showIframeModal = true;
        },
        closeIframeModal() {
            this.showIframeModal = false;
        },
        async toggleIframe(iframe) {
            try {
                const response = await requestV2.put(`/courses/${iframe.id}/toggle`);
                iframe.ativo = response.data.ativo;
                if (iframe.ativo) {
                    alert(`O iFrame "${iframe.nome}" foi ativado e já está aparecendo no seu site novamente.`);
                } else {
                    alert(`O iFrame "${iframe.nome}" foi desativado temporariamente.`);
                }
            } catch (err) {
                console.error('Erro ao alternar iFrame:', err);
                alert('Erro ao alternar status do iFrame.');
            }
        },
        async saveIframe(iframeData) {
            if (!iframeData.nome || iframeData.materiaisSelecionados.length === 0) {
                alert('Preencha o nome e selecione pelo menos um material.');
                return;
            }

            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1;
                const allowed_domains = iframeData.restrictionType === 'restricted'
                    ? iframeData.allowedDomainsList
                    : [];

                if (iframeData.id) {
                    // Atualizar existente
                    await requestV2.put(`/courses/${iframeData.id}`, {
                        nome: iframeData.nome,
                        materiaisSelecionados: iframeData.materiaisSelecionados,
                        allowed_domains
                    });
                    alert('Curso atualizado com sucesso!');
                } else {
                    // Criar novo
                    await requestV2.post('/courses', {
                        partner_id: partnerId,
                        nome: iframeData.nome,
                        materiaisSelecionados: iframeData.materiaisSelecionados,
                        allowed_domains
                    });
                    alert('Curso / iFrame criado com sucesso!');
                }
                this.closeIframeModal();
                this.loadIframes(); // Recarrega a lista
            } catch (err) {
                console.error('Erro ao salvar iFrame:', err);
                alert('Erro ao salvar curso/iFrame.');
            }
        },
        copyIframeCode(iframe) {
            const url = `${window.location.origin}/#/embed/${iframe.hash}`;
            const code = `<iframe id="asas-curso-${iframe.hash}" src="${url}" width="100%" height="600" frameborder="0" allowfullscreen></iframe>
<script>
/**
 * Integração ASAS - Identificação do Aluno
 * Substitua os valores abaixo pelos dados do aluno logado no seu sistema.
 */
document.getElementById('asas-curso-${iframe.hash}').addEventListener('load', function() {
  const targetOrigin = new URL(this.src).origin;
  this.contentWindow.postMessage({
    type: 'STUDENT_AUTH',
    student_id: 'SUBSTITUIR_PELO_ID_DO_ALUNO',
    student_name: 'SUBSTITUIR_PELO_NOME',
    student_email: 'SUBSTITUIR_PELO_EMAIL'
  }, targetOrigin);
});
</${'script'}>`;
            navigator.clipboard.writeText(code).then(() => {
                alert('Código do iFrame copiado para a área de transferência!');
            }).catch(err => {
                console.error('Erro ao copiar código: ', err);
            });
        },
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        },
        formatItemType(tipo) {
            const tipos = {
                'material-didatico': 'Material Didático',
                'video-aula': 'Vídeo Aula',
                'atividade': 'Atividade',
                'pacote-completo': 'Pacote Completo',
                'pacote': 'Pacote Completo'
            };
            return tipos[tipo] || tipo || 'Não definido';
        },
        formatPrice(preco) {
            if (!preco) return '0,00';
            return parseFloat(preco).toFixed(2).replace('.', ',');
        },
        formatarData(dataStr) {
            if (!dataStr) return '';
            let data;
            if (dataStr.includes(' ') || (dataStr.includes('T') && dataStr.length > 10)) {
                data = new Date(dataStr.replace(' ', 'T'));
            } else {
                data = new Date(dataStr + 'T00:00:00');
            }
            if (isNaN(data.getTime())) {
                data = new Date(dataStr);
            }
            return isNaN(data.getTime()) ? 'Data Inválida' : data.toLocaleDateString('pt-BR');
        },
        calcularDias(dataStr) {
            if (!dataStr) return '';
            let dataPagamento;
            if (dataStr.includes('T')) {
                dataPagamento = new Date(dataStr);
            } else {
                dataPagamento = new Date(dataStr + 'T00:00:00');
            }
            
            if (isNaN(dataPagamento.getTime())) return '';

            const hoje = new Date();
            const diferencaTempo = dataPagamento.getTime() - hoje.getTime();
            const diasDeDiferenca = Math.ceil(diferencaTempo / (1000 * 3600 * 24));

            if (diasDeDiferenca > 0) {
                return `Daqui a ${diasDeDiferenca} dias`;
            } else if (diasDeDiferenca === 0) {
                return 'Vence Hoje';
            } else {
                return `Atrasado há ${Math.abs(diasDeDiferenca)} dias`;
            }
        },
        async loadPartnerData() {
            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1;
                const response = await requestV2.get(`/partners/${partnerId}`);
                const data = response.data;

                this.dashboardKpis.totalAccesses = data.total_accesses || 0;
                this.dashboardKpis.usedAccesses = data.used_accesses || 0;
                this.dashboardKpis.licensedMaterials = data.licensed_materials || 0;

                const subsResponse = await requestV2.get('/subscriptions');
                this.assinaturas = subsResponse.data;
            } catch (err) {
                console.error('Erro ao carregar dados do parceiro:', err);
            }
        },
        async loadIframes() {
            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1;
                const response = await requestV2.get(`/courses?partner_id=${partnerId}`);
                this.iframes = response.data;
            } catch (err) {
                console.error('Erro ao carregar iFrames:', err);
            }
        }
    },
    async mounted() {
        const userData = localStorage.getItem('user');
        if (userData) {
            try {
                this.userProfile = JSON.parse(userData);
            } catch (e) {
                console.error("Erro ao ler user_data", e);
            }
        }

        if (!this.isInstitutionalAdmin) {
            this.carregarMateriais();
        } else {
            // Se for admin institucional (parceiro), carrega as informações do banco via API
            this.carregarMateriais(); // Necessário para a seleção de materiais do iFrame
            await this.loadPartnerData();
            await this.loadIframes();
            this.loading = false;
        }
    }
}
</script>

<style scoped src="../styles/Manage.css" />